import AppRoot from '../../../external/feed-page/containers/app-root';
import { withViewer } from '../../../external/common/hoc/with-viewer';

export default withViewer(AppRoot);
